import React from 'react';

interface HeaderProps {
  title: string | JSX.Element;
  adjacentTitleButtons?: JSX.Element | null;
  subtitle?: string | JSX.Element;
}

const Header = ({ title, adjacentTitleButtons, subtitle }: HeaderProps) => (
  <div
    className={`flex items-center justify-between  md:items-start ${
      title ? 'mb-6' : ''
    } `}
  >
    <div>
      <h2 className="text-xl font-bold md:text-2xl text-neutral-20 ">{title}</h2>
      {subtitle && <p className="text-sm text-neutral-70 ">{subtitle}</p>}
    </div>
    {adjacentTitleButtons && <div>{adjacentTitleButtons}</div>}
  </div>
);

export default React.memo(Header);
